// API 环境配置
const server_url = process.env.VUE_APP_URL 
const upload_url = process.env.VUE_APP_UPLOAD_URL || server_url

module.exports = {
  server_url,
  upload_url,
  title: process.env.VUE_APP_TITLE || '百工人服'
}
